import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import brands from "../src/Json/Brand.json";
const LibasMenuDesigners = ({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const BrandsSection = [
    { id: "UXo5X4BP3lMoimmkMNrO" },
    { id: "nMmJX9z74ZJy98M4zse4" },
    { id: "9euIqdADV2sXs49OoXIs" },
    { id: "k2mIsRr2C2Jax6TlitBG" },
    { id: "YETcI5UACzR21ktVty4G" },
    { id: "htjMB0lyqYD7dqviSd58" },
    { id: "RiE6OzHvJgxyrv0PjE3G" },
    { id: "HOg0VXl7VqKzDg7wqn52" },
    { id: "NAHb0mOIuEtPZcqMAn94" },
    { id: "SQImHuAPQcivU49D9Obf" },
  ];
  const BrandsSection2 = [
    { id: "MJSVOzPBi2vsGFu55Y7A" },
    { id: "Dzr5aum2QhF8h8rDMyrw" },
    { id: "6gCg1qU5mt67YBafPupL" },
    { id: "1qzwoL33uzzcKF9rlSrP" },
    { id: "CEjaAw6tesKQhzGBnkZe" },
    { id: "bsDmPUaLYKPCwoxLlTw0" },
    { id: "k1MUggevPUVeP4OdQA3K" },
    { id: "brvXCtEhGyu3rUs9VrcT" },
    { id: "I3Nr0lHpoWrYxLw5nzsf" },
    { id: "a6FVMVxnhctfJprZmzzK" },
  ];
  const BrandsSection3 = [
    { id: "XfeeY5SoK8Ez16rAzJaH" },
    { id: "n3zJLouTWNwZnfToQxtI" },
    { id: "ng1wdK8d3lF6il3VQGae" },
    { id: "85oOOzNJVd2ArnTSJJYw" },
    { id: "gx48EN58tk80Kcwgl1xY" },
    { id: "vsUMeHPID1Rs7QdZiHD3" },
    { id: "i2u0Wg3fhUIrtsWegpsM" },
    { id: "iBJgqgPm9in6WB4B5aG1" },
  ];
  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* New Arrival */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("designers")}
          style={{
            borderBottom:
              expandedCategory === "designers" ? "none" : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "designers" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "designers" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/brands"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "designers") {
                setHide(true);
                return;
              } else {
                setActiveFilter("designers");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "designers" ? "500" : "400",
                textDecoration:
                  expandedCategory === "designers" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Designers")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "mens" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "designers" ? menuup : menudown}
              alt="expandedCategory"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "designers" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of newArrival */}
                  <ul className="list-unstyled">
                    {/* new arrivals with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div
                        className="d-flex justify-content-between align-items-start"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {BrandsSection?.map((brandsection) => (
                          <>
                            {brands
                              ?.filter((brand) => brand?.id == brandsection?.id)
                              ?.map((brand) => (
                                <div
                                  className="subtitlemega pb-3 d-flex flex-col"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Link
                                    to={`/products?brand=${brand.id}&nameBrand=${brand.name}`}
                                    className="subtitlemega "
                                    onClick={() => {
                                      // If this filter is already active, return
                                      if (activeFilter === "designers") {
                                        setHide(true);
                                        return;
                                      } else {
                                        // If activating a new filter, set it as active and reset filters
                                        setActiveFilter("designers");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark"
                                      style={{
                                        marginLeft: "15px",
                                      }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "newArrival",
                                          "clothes"
                                        )
                                      }
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </motion.button>
                                  </Link>
                                </div>
                              ))}
                          </>
                        ))}
                        {BrandsSection2?.map((brandsection) => (
                          <>
                            {brands
                              ?.filter((brand) => brand?.id == brandsection?.id)
                              ?.map((brand) => (
                                <div
                                  className="subtitlemega pb-3 d-flex flex-col"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Link
                                    to={`/products?brand=${brand.id}&nameBrand=${brand.name}`}
                                    className="subtitlemega "
                                    onClick={() => {
                                      // If this filter is already active, return
                                      if (activeFilter === "designers") {
                                        setHide(true);
                                        return;
                                      } else {
                                        // If activating a new filter, set it as active and reset filters
                                        setActiveFilter("designers");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark"
                                      style={{
                                        marginLeft: "15px",
                                      }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "newArrival",
                                          "clothes"
                                        )
                                      }
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </motion.button>
                                  </Link>
                                </div>
                              ))}
                          </>
                        ))}
                        {BrandsSection3?.map((brandsection) => (
                          <>
                            {brands
                              ?.filter((brand) => brand?.id == brandsection?.id)
                              ?.map((brand) => (
                                <div
                                  className="subtitlemega pb-3 d-flex flex-col"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Link
                                    to={`/products?brand=${brand.id}&nameBrand=${brand.name}`}
                                    className="subtitlemega "
                                    onClick={() => {
                                      // If this filter is already active, return
                                      if (activeFilter === "designers") {
                                        setHide(true);
                                        return;
                                      } else {
                                        // If activating a new filter, set it as active and reset filters
                                        setActiveFilter("designers");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark"
                                      style={{
                                        marginLeft: "15px",
                                      }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "newArrival",
                                          "clothes"
                                        )
                                      }
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </motion.button>
                                  </Link>
                                </div>
                              ))}
                          </>
                        ))}
                        {/* all brands */}
                        <Link
                          to={`/brands`}
                          className="subtitlemega px-3"
                          style={{
                            fontWeight: "600",
                          }}
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "designers") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("designers");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          All Brands
                        </Link>
                      </div>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default LibasMenuDesigners;
